import { css, styled } from 'styled-components';

export const Wrapper = styled.div<{ $marketplaceEnabled: boolean }>`
    width: 100%;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    @media (max-width: 1380px) {
        flex-direction: column-reverse;
        gap: 0px;
        align-items: flex-start;
    }

    @media (max-width: 768px) {
        padding-top: 10px;
    }

    ${({ $marketplaceEnabled }) =>
        !$marketplaceEnabled &&
        css`
            padding-top: 0;
            border-top: none;

            @media (max-width: 768px) {
                padding-top: 0px;
            }
        `}
`;
